<template>
    <Container>
        <div class="mt-[120px]">
            <div class="grid grid-cols-3 gap-[66px] text-center">
                <div>
                    <span class="inline-block text-[48px] font-[700] mb-[18px]">3000</span>

                    <p class="text-[19px]">
                        Teachers who teach about climate change through our climate hub
                    </p>
                </div>

                <div>
                    <span class="inline-block text-[48px] font-[700] mb-[18px]">3000</span>

                    <p class="text-[19px]">
                        Teachers who teach about climate change through our climate hub
                    </p>
                </div>

                <div>
                    <span class="inline-block text-[48px] font-[700] mb-[18px]">3000</span>

                    <p class="text-[19px]">
                        Teachers who teach about climate change through our climate hub
                    </p>
                </div>
            </div>
        </div>
    </Container>
</template>

<script>
import Container from '../../../Layouts/Container'

export default {
    components: {
        Container,
    },
}
</script>
